// removed by extract-text-webpack-plugin
module.exports = {"light-grey":"#d4d4d4","background-grey":"#f6f6f6","white":"_2lBD8U9tAIzk-jhLI14uiX","black":"#000000","tag":"_2P-8z4bet3mC80zkTjCxpI","active":"_6FWQ72jzpz9M0MMbmNK1Y","disable":"_1bmpnEiz3cNNBurTPhu1eD","circle":"_16T9Fpm9I-7mkFPQmRDCvZ","icon10":"_1pIU5NeUiH5DkJkWNniJQX","icon15":"efvm1jhR3VgPqC8sIQwvA"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/elements/Tags/FiltersTag/FilterTag/FilterTag.css
// module id = 1171
// module chunks = 0